import { Suspense, PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { fallBack } from '../../router/RouterApp';
import CallMeScreenView from '../call-me/CallMeScreen.view';
import { IAppProps, REDUCER_KEY } from '../../common/interface/IAppProvider';
import { OverlayDialog } from '@flos/react-components';
import { useGlobalDispatch, useGlobalState } from '../../common/context/AppContext';
import CallMeReceiptView from '../call-me-receipt/CallMeReceipt.view';

export type rmoState = {
    rmoState: (key: string, val: boolean) => void;
};

const DynamicModalScreenView = (props: PropsWithChildren<IAppProps> & rmoState): JSX.Element => {
    const appDispatch = useGlobalDispatch();
    const globalState = useGlobalState();
    const navigate = useNavigate();

    const handleOncloseEvent = (_event: any, reason: any) => {
        if (reason !== 'backdropClick') {
            appDispatch({
                type: REDUCER_KEY.SET_ERROR,
                payload: { stepOne: false, stepTwo: false, separateCallMe: false },
            });
            navigate(-1);
        }
    };

    return globalState.hasError.stepOne || (globalState.hasError.stepTwo && !globalState.hasError.separateCallMe) ? (
        <div>
            <OverlayDialog transitionDuration={0} scroll={'paper'} open={true} onClose={handleOncloseEvent}>
                {globalState.hasError.stepOne ? (
                    <Suspense fallback={fallBack}>
                        <CallMeScreenView {...props} />
                    </Suspense>
                ) : (
                    <Suspense fallback={fallBack}>
                        <CallMeReceiptView {...props} />
                    </Suspense>
                )}
            </OverlayDialog>
        </div>
    ) : (
        <></>
    );
};

export default DynamicModalScreenView;
